export default __webpack_public_path__ + "static/Artboard-1-c442d216f8c7e8379e90a346bb7f28b7.webp";